import { Box, Typography } from '@mui/material'
import EnhancedTabs from '@common/components/Tab/EnhancedTabs'
import { CurrentActiveTabProvider } from '@common/context/CurrentActiveTabProvider'
import { TabOptionalComponentProvider } from '@common/context/TabOptionalComponentProvider'
import { useCombinedPermissions } from '@auth/hooks/useCombinedPermissions'
import { useParams } from 'react-router-dom'
import { SearchProvider } from '@common/context/SearchProvider'
import { createReaderTasksTabs, ReaderTaskListTabsKey } from '@features/reader_task_list_iam_view/pages/readerTasksTabs'
import { TabConfig } from '@common/components/Tab/tabs.types'

const SubjectReaderTasks = () => {
  const { hasPermission } = useCombinedPermissions()
  const { subjectId } = useParams<{ studyId: string; subjectId: string }>()

  const readerTasksTabs = createReaderTasksTabs(subjectId)

  const filteredTabs = Object.entries(readerTasksTabs).reduce(
    (acc, [key, tab]) => {
      if (!tab.permission || hasPermission(tab.permission)) {
        acc[key as ReaderTaskListTabsKey] = tab
      }
      return acc
    },
    {} as Record<ReaderTaskListTabsKey, TabConfig>,
  )

  if (!subjectId) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" color="error">
          Subject ID is required to view subject read tasks
        </Typography>
      </Box>
    )
  }

  return (
    <SearchProvider>
      <CurrentActiveTabProvider>
        <TabOptionalComponentProvider>
          {Object.keys(filteredTabs).length > 0 && <EnhancedTabs tabs={filteredTabs} searchEnabled />}
        </TabOptionalComponentProvider>
      </CurrentActiveTabProvider>
    </SearchProvider>
  )
}

export default SubjectReaderTasks
